import { useContext } from 'react';
import { toast } from 'react-toastify';
import { Spinner } from '@ds';
import { Form } from '@ui';
import { AuthContext } from '@lp/core/auth';
import { SchedulerSettingsSubmitRow } from '@lp/features/Scheduler/components';
import { CSSchedulerSettingsRulesFormType } from '@lp/features/Scheduler/SchedulerClinicalSpecialistsSettings/types';
import { CSSchedulerSettingsRulesForm } from '@lp/features/Scheduler/SchedulerClinicalSpecialistsSettings/components';
import {
  csSchedulerSettingsRulesFormSchema,
  getDefaultCSSchedulerRulesValues,
} from '@lp/features/Scheduler/SchedulerClinicalSpecialistsSettings/config';
import { useCSScheduleSettingsRulesQuery, useCSSetScheduleSettingsRulesMutation } from '@/queries/resource/schedule';
import { retrieveUnifiedError } from '@/api/utils';
import { SchedulerPermissions } from '@/permissions';

export const CSSchedulerSettingsRulesTab = () => {
  const { checkPermission } = useContext(AuthContext);
  const { data } = useCSScheduleSettingsRulesQuery();
  const { mutateAsync, isPending } = useCSSetScheduleSettingsRulesMutation();

  const hasWritePermissions = checkPermission(SchedulerPermissions.CSSchedulesSettingsRulesWrite);

  const handleSubmit = async (formData: CSSchedulerSettingsRulesFormType) => {
    try {
      await mutateAsync(formData);
      toast.success(`Scheduler Rules updated successfully`);
    } catch (e) {
      const error = retrieveUnifiedError(e);
      toast.error(error.message);
    }
  };

  return (
    <div className="flex flex-col">
      {data ? (
        <Form<CSSchedulerSettingsRulesFormType>
          defaultValues={getDefaultCSSchedulerRulesValues(data)}
          schema={csSchedulerSettingsRulesFormSchema}
          onSubmit={handleSubmit}
        >
          <CSSchedulerSettingsRulesForm isReadOnly={!hasWritePermissions} />
          <SchedulerSettingsSubmitRow backPath="/schedule/cs" isLoading={isPending} isReadOnly={!hasWritePermissions} />
        </Form>
      ) : (
        <Spinner />
      )}
    </div>
  );
};
